import React from 'react';

const context = React.createContext();

export const Data = {
    color: {
        theme: '#4CA376',
        themeSecondary: '#577972',
        bg: '#091F2C',
        body: '#f8fafc',
        text: '#DDD4C8'
    },
    screen: {
        breakpoint: {
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200
        }
    }
}

export const Provider = context.Provider;
export const Consumer = context.Consumer;

export default context;
